export default __webpack_public_path__ + "static/media/checkPilot.f042c049.png";